// * SET
export const SET_LOADING_USER_DATA = 'user/SET_LOADING_USER_DATA';

// * FETCH
export const FETCH_USER_BY_ID = 'user/FETCH_USER_BY_ID';
